import { combineReducers } from '@reduxjs/toolkit';
import { monthlyPayoutReducer } from 'features/revenue/itemSales/monthlyPayoutSlice';
import { revenueDetailReducer } from 'features/revenue/itemSales/revenueDetailSlice';
import { sellerRevenueReducer } from 'features/revenue/itemSales/sellerRevenueSlice';
import { withholdingTaxReducer } from 'features/revenue/itemSales/withhodingTaxSlice';

export const revenueReducer = combineReducers({
  seller: sellerRevenueReducer,
  monthly: monthlyPayoutReducer,
  detail: revenueDetailReducer,
  withholdingTax: withholdingTaxReducer,
});
